import get = require('lodash/get');
import {Room} from 'twilio-video';

import {
    IVideoAction,
    VIDEO_CONNECT_PENDING,
    VIDEO_CONNECT_FULFILLED,
    VIDEO_DISCONNECT,
    VIDEO_SEND_SCREEN,
    VIDEO_SEND_SCREEN_STOP,
    VIDEO_SEND_SCREEN_ERROR,
    VIDEO_SEND_SCREEN_ERROR_CONFIRM,
    VIDEO_UPDATE_STATUS,
} from './actions';

import {
    STATUS_CONNECTED,
    STATUS_DISCONNECTED,
} from './constants';

import {
    WS_CONNECTED_ELSEWHERE,
    WS_UPDATE_PEER_STATUS,
} from '../web-socket/constants';

export interface IVideoState {
    cleanup: () => void;
    isSendingScreen: boolean;
    sendScreenError: string;
    room: Room;
    shouldConnect: boolean;
    status: string;
    peerStatus: string;
}

const initialState: IVideoState = {
    cleanup: undefined,
    isSendingScreen: false,
    sendScreenError: undefined,
    room: undefined,
    shouldConnect: false,
    status: STATUS_DISCONNECTED,
    peerStatus: STATUS_DISCONNECTED,
};

export const videoReducer = (
    state: IVideoState = initialState,
    action: IVideoAction,
): IVideoState => {
    switch (action.type) {
        case VIDEO_CONNECT_PENDING:
            const cleanup = get(action, 'meta.cleanup');
            if (cleanup && state.cleanup) {
                state.cleanup();
            }
            return {...state, shouldConnect: true, cleanup: cleanup || state.cleanup};

        case VIDEO_CONNECT_FULFILLED:
            // If we tried to disconnected in the middle of connecting, finish disconnecting.
            if (!state.shouldConnect) {
                action.payload.disconnect();
            }

            if (state.room) {
                state.room.disconnect();
            }
            return {...state, room: action.payload, status: STATUS_CONNECTED};

        case VIDEO_DISCONNECT:
            if (action.shouldCleanup && state.cleanup) {
                state.cleanup();
            }
            if (state.room) {
                state.room.disconnect();
            }
            return {...state, shouldConnect: false, status: STATUS_DISCONNECTED};

        case VIDEO_SEND_SCREEN:
            return {...state, isSendingScreen: true};

        case VIDEO_SEND_SCREEN_STOP:
            return {...state, isSendingScreen: false};

        case VIDEO_SEND_SCREEN_ERROR:
            return {...state, sendScreenError: action.errorName};

        case VIDEO_SEND_SCREEN_ERROR_CONFIRM:
            return {...state, sendScreenError: undefined};

        case VIDEO_UPDATE_STATUS:
            return {...state, status: action.status};

        case WS_UPDATE_PEER_STATUS:
            return {...state, peerStatus: action.payload.status};

        case WS_CONNECTED_ELSEWHERE:
            return initialState;

        default:
            return state;
    }
};
